export default {
	'dashboard.SalesCard.today': 'Hôm nay',
	'dashboard.SalesCard.thisWeek': 'Tuần này',
	'dashboard.SalesCard.thisMonth': 'Tháng này',
	'dashboard.SalesCard.thisYear': 'Năm nay',
	'dashboard.SalesCard.sales': 'Doanh số',
	'dashboard.SalesCard.salesVolume': 'Số lượng bán',
	'dashboard.SalesCard.salesRank': 'Xếp hạng doanh số chi nhánh',
	'dashboard.SalesCard.views': 'Lợi Nhuận',
	'dashboard.SalesCard.viewsVolume': 'Số lượt truy cập',
	'dashboard.SalesCard.viewsRank': 'Xếp hạng lợi nhuận chi nhánh',
	'dashboard.SalesCard.storeNumber': 'Chi nhánh số {number}',
	// Tooltip labels
	'dashboard.SalesCard.tooltip.sales': 'Số lượng bán',
	'dashboard.SalesCard.tooltip.visits': 'Số lượt truy cập',
}